function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 34,
  cy: 34,
  r: 34,
  fill: "#00BB6E"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M27.97 38.502c.01-.031.022-.078.036-.137.055-.237.073-.478.037-.679-.086-.483-.473-.707-1.723-.543a4.947 4.947 0 0 1-1.522.025c-2.184-.323-2.657-2.133-.71-4.958l9.618-14.724c.146-.224.268-.425.511-.838l.054-.09c.619-1.041 1.787-1.775 3.602-1.775h10.074l.075.003c.221.019.495.086.78.248 1.136.645 1.136 1.983-.144 3.725l-6.29 9.535c-.22.326-.39.7-.502 1.099-.114.416-.13.752-.062.91.014.032.021.04.049.051.092.04.268.057.549.023a6.763 6.763 0 0 1 1.37-.004c.91.096 1.59.39 1.846 1.099.287.79-.182 1.65-1.303 2.696-1.252 1.17-5.007 4.982-10.442 10.574-3.57 3.673-7.413 7.65-10.255 10.6a2.577 2.577 0 0 1-1.79.83c-1.934.049-2.193-1.634-.641-4.404l6.783-13.266z"
}));

var SvgUpgrade = function SvgUpgrade(props) {
  return React.createElement("svg", _extends({
    width: 68,
    height: 68
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/upgrade.974296a7.svg";
export { SvgUpgrade as ReactComponent };